import { SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { UtilsService } from '../../core/utils.service';

@Pipe({
  name: 'pharTransformTimeUnit',
})
export class TimeUnitConverterPipe implements PipeTransform {
  private utilsService = inject(UtilsService);


  transform(value: string | number, unit: number, prefix?: string, suffix?: string, fullUnitName?: boolean): SafeHtml {
    return `${prefix || ''}${value ?? ''}${this.utilsService.unitToName(unit, fullUnitName)}${suffix || ''}`;
  }
}
